import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from './ui/Shared';
export const ValuesGrid = () => {
  const values = [{
    gurmukhi: 'ਨਿਡਰਤਾ',
    title: 'Courage',
    def: 'The audacity to tackle hard problems.',
    desc: "We don't shy away from complex civic issues. You will learn to step into the arena."
  }, {
    gurmukhi: 'ਸੇਵਾ',
    title: 'Service',
    def: 'Leadership as an act of giving.',
    desc: 'Rooted in Seva, we build solutions that uplift the community, not just the individual.'
  }, {
    gurmukhi: 'ਨਿਆਂ',
    title: 'Justice',
    def: 'Advocating for structural fairness.',
    desc: 'Moving beyond charity to address the root causes of inequity in our cities.'
  }, {
    gurmukhi: 'ਨੇਮ',
    title: 'Discipline',
    def: 'The rigor to see things through.',
    desc: 'Ideas are easy. Execution requires focus, structure, and relentless effort.'
  }, {
    gurmukhi: 'ਨਿਮਰਤਾ',
    title: 'Humility',
    def: 'Listening before leading.',
    desc: 'Understanding stakeholders deeply before assuming you have the right answer.'
  }, {
    gurmukhi: 'ਜ਼ਿੰਮੇਵਾਰੀ',
    title: 'Responsibility',
    def: 'Owning the outcome.',
    desc: 'Taking accountability for your team, your project, and your impact on the world.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section id="why" className="py-24 md:py-32 bg-ivory relative overflow-hidden" data-id="element-307">
      <div className="absolute inset-0 bg-noise pointer-events-none" data-id="element-308" />

      {/* Decorative background element */}
      <motion.div animate={{
      rotate: -360
    }} transition={{
      duration: 200,
      repeat: Infinity,
      ease: 'linear'
    }} className="absolute -left-64 top-1/4 w-[600px] h-[600px] border-[1px] border-gold/5 rounded-full pointer-events-none" data-id="element-309" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-310">
        <SectionHeader title="Six principles. One operating system." subtitle="Rooted in the heritage of Khalsa Raj, these are the core values that drive our approach to leadership and venture building." data-id="element-311" />

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-312">
          {values.map(val => <motion.div key={val.title} variants={itemVariants} whileHover={{
          y: -5,
          scale: 1.01
        }} className="p-8 border border-bronze/10 bg-parchment/30 hover:bg-ivory hover:border-kesari/40 transition-all duration-300 group relative overflow-hidden shadow-sm hover:shadow-[0_10px_30px_rgba(212,118,60,0.05)]" data-id="element-313">
              <div className="absolute top-0 right-0 w-16 h-16 bg-gradient-to-bl from-kesari/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-314" />

              <div className="flex items-center justify-between mb-6" data-id="element-315">
                <div className="w-10 h-10 text-gold group-hover:text-kesari transition-colors" data-id="element-316">
                  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full h-full group-hover:scale-110 transition-transform duration-500" data-id="element-317">
                    <path d="M20 0L40 20L20 40L0 20Z" stroke="currentColor" strokeWidth="1.5" data-id="element-318" />
                    <circle cx="20" cy="20" r="8" stroke="currentColor" strokeWidth="1.5" data-id="element-319" />
                    <circle cx="20" cy="20" r="2" fill="currentColor" className="opacity-0 group-hover:opacity-100 transition-opacity delay-100" data-id="element-320" />
                  </svg>
                </div>
                <span className="font-gurmukhi text-kesari/40 group-hover:text-kesari/80 text-xl transition-colors" data-id="element-321">
                  {val.gurmukhi}
                </span>
              </div>

              <h3 className="font-serif text-2xl text-navy mb-2" data-id="element-322">
                {val.title}
              </h3>
              <p className="font-sans text-sm font-semibold text-gold group-hover:text-kesari transition-colors mb-3" data-id="element-323">
                {val.def}
              </p>
              <p className="font-sans text-sm text-charcoal/70 leading-relaxed" data-id="element-324">
                {val.desc}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};